import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import '../../assets/css/admin/allcourses.css';
import axios from 'axios';

const AppliedForms = () => {
  const [applications, setApplications] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredApplications, setFilteredApplications] = useState([]);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const response = await axios.get('https://api.myskills.lk/apply/appliedforms');
        setApplications(response.data);
        setFilteredApplications(response.data); // Initialize filteredApplications with all data
      } catch (error) {
        console.error('Error fetching applications:', error);
      }
    };

    fetchApplications();
  }, []);

  // This effect runs whenever searchTerm or applications change
  // to provide real-time filtering
  useEffect(() => {
    if (!searchTerm.trim()) {
      // If search is empty, show all applications
      setFilteredApplications(applications);
      return;
    }
    
    // Filter applications based on multiple fields
    const filtered = applications.filter(application => 
      (application.firstName && application.firstName.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (application.lastName && application.lastName.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (application.email && application.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (application.levelOfStudy && application.levelOfStudy.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (application.contact && application.contact.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (application.address && application.address.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (application.jobtit && application.jobtit.toLowerCase().includes(searchTerm.toLowerCase()))
    );
    
    setFilteredApplications(filtered);
  }, [searchTerm, applications]);
  
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    // No need for e.preventDefault() since we want it to update as we type
  };
  
  return (
    <div>
      <AdminDashboard />

      <div className='AllViews-admin-course'>
        <div className="search-icon-admin admin-course-search">
          <h1>APPLIED FORMS</h1>
          <form>
            <input 
              type="text" 
              value={searchTerm}
              onChange={handleSearch} 
              placeholder='Search Item' 
            />
            <input type="submit" value="SEARCH" onClick={(e) => e.preventDefault()} />
          </form>
        </div>

        <div className="scroller-box">
          <div className="table-course">
            <table>
              <thead>
                <tr>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Contact</th>
                  <th>DOB</th>
                  <th>Address</th>
                  <th>Email</th>
                  <th>Level of Study</th>
                  <th>Message</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {filteredApplications.length > 0 ? (
                  filteredApplications.map((app) => (
                    <tr key={app.id}>
                      <td>{app.firstName}</td>
                      <td>{app.lastName}</td>
                      <td>{app.contact}</td>
                      <td>{new Date(app.dob).toLocaleDateString('en-CA')}</td>
                      <td>{app.address}</td>
                      <td>{app.email}</td>
                      <td>{app.levelOfStudy}</td>
                      <td>{app.message}</td>
                      <td id='action-buttons'>
                      <a href={`mailto:${app.email}?subject=Reply to your application&body=Dear ${app.firstName},`} id='app-details'>REPLY</a>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" style={{textAlign: 'center'}}>No applications found matching your search</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppliedForms;
